module.exports = __webpack_public_path__ + "static/retail-fs-783ec54ec5c931955b7f7d6745cb3a3c.jpg";